// extracted by mini-css-extract-plugin
export default {"customToastContainer":"styles_customToastContainer__wuc8j"};